<template>
  <div v-if="renderQuestion(0)">
    <br>
    <div class="ui dividing sub header">Demographics</div>
    <div class="required field" style="margin-bottom:0;" v-if="renderQuestion(7)">
      <br>
      <label class="german">Geschlecht</label>
      <label>Gender</label>
      <select class="ui search fluid dropdown" id="demo-7">
        <option value="">Please choose one</option>
        <option value="1"><span class="german">Männlich</span> | Male</option>
        <option value="2"><span class="german">Weiblich</span> | Female</option>
      </select>
    </div>


    <div class="required field" style="margin-bottom:0;" v-if="renderQuestion(1)">
      <br>
      <label class="german">Bitte geben Sie Ihr Alter ein.</label><label>Please enter your age</label>
      <input type="number" id="demo-1">
    </div>

    <div class="required field" v-if="renderQuestion(2)">
      <br>
      <label class="german">Sind Sie ein Angestellter von Novartis oder ist eines Ihrer Familienmitglieder bei Novartis beschäftigt?</label>
      <label>Are you an NVS employee or family member of someone employed at Novartis?</label>
      <select class="ui search fluid dropdown" id="demo-2">
        <option value="">Please choose one</option>
        <option value="1"><span class="german">Novartis-Mitarbeiter</span> | Novartis Employee</option>
        <option value="2"><span class="german">Familienmitglied</span> | Family Member</option>
      </select>
    </div>

    <div class="required field" v-if="renderQuestion(3)">
      <br>
      <label class="german">Wie lange sind Sie bereits von Migräne betroffen?</label>
      <label>How long have you been affected by migraine?</label>

      <select class="ui search fluid dropdown" id="demo-3">
        <option value="">Please choose one</option>
        <option value="1"><span class="german">Weniger als 1 Jahr</span> | Less than a year</option>
        <option value="2"><span class="german">1–5 Jahre</span> | 1 - 5 years</option>
        <option value="3"><span class="german">6–10 Jahre</span> | 6 - 10 years</option>
        <option value="4"><span class="german">11–15 Jahre</span> | 11 - 15 years</option>
        <option value="5"><span class="german">16–20 Jahre</span> | 16 - 20 years</option>
        <option value="6"><span class="german">21 Jahre oder länger</span> | 21 years or more</option>
      </select>
    </div>

    <div class="required field" v-if="renderQuestion(4)">
      <br>
      <label class="german">Wann, wenn überhaupt, wurde bei Ihnen Migräne medizinisch diagnostiziert?</label>
      <label>If at all, when were you medically diagnosed with migraine?</label>
      <select class="ui search fluid dropdown" id="demo-4">
        <option value="">Please choose one</option>
        <option value="1"><span class="german">Keine medizinische Migräne-Diagnose</span> | No medical diagnosis of migraine</option>
        <option value="2"><span class="german">In den letzten 3 Monaten</span> | In the last 3 months</option>
        <option value="3"><span class="german">Vor 3–6 Monaten</span> | 3 - 6 months ago</option>
        <option value="4"><span class="german">Vor 7–11 Monaten</span> | 7 - 11 months ago</option>
        <option value="5"><span class="german">Vor 1–2 Jahren</span> | 1 - 2 years ago</option>
        <option value="6"><span class="german">Vor 3–5 Jahren</span> | 3 - 5 years ago</option>
        <option value="7"><span class="german">Vor 6–9 Jahren</span> | 6 - 9 years ago</option>
        <option value="8"><span class="german">Vor mehr als 10 Jahren</span> | 10 years plus</option>
      </select>
    </div>

    <div class="required field" v-if="renderQuestion(5)">
      <br>
      <label class="german">Werden Sie bzw. Ihre Migräne von einem Arzt behandelt?</label>
      <label>Are you being treated by an HCP for your migraine?</label>
      <select multiple class="ui search fluid dropdown" id="demo-5">
        <option value="">Please select all the apply</option>
        <option value="1"><span class="german">Nein</span> | No</option>
        <option value="2"><span class="german">Ja, durch einen Arzt</span> | Yes by physician</option>
        <option value="3"><span class="german">Ja, vom Arzt an einen Spezialisten überwiesen</span> | Yes referred by physician to specialist</option>
        <option value="4"><span class="german">Ja, Behandlung durch einen Spezialisten (nicht mehr in Behandlung)</span> | Yes treated by specialist (not anymore)</option>
        <option value="5"><span class="german">Ja, Behandlung durch einen Spezialisten (noch in Behandlung)</span> | Yes treated by specialist (actively)</option>
      </select>
    </div>

    <div class="required field" v-if="renderQuestion(6)">
      <br>
      <label class="german">Wenn Sie an die letzten 3 Monate denken, welche Art von Behandlungen haben Sie gegebenenfalls für Ihre Migräne angewendet?</label>
      <label>Thinking over the last 3 months, what type of treatments, if any, were you using to treat your migraines?</label>
      <select multiple class="ui search fluid dropdown" id="demo-6">
        <option value="">Please select all that apply</option>
        <option value="1"><span class="german">Keine</span> | None</option>
        <option value="2"><span class="german">Rezeptfreie Schmerzmittel (nicht verschreibungspflichtig)</span> | OTC painrelievers (without prescription)</option>
        <option value="3"><span class="german">Vom Arzt verschriebene akute Medikation</span> | Acute treatment prescribed by a doctor</option>
        <option value="4"><span class="german">Vom Arzt verschriebene präventive Medikation</span> | Preventative medication prescribed by doctor</option>
        <option value="5"><span class="german">Gerät zur Migräneprävention - Cefaly Neuro</span> | Preventative device - Cefaly Neuro</option>
        <option value="6"><span class="german">Vitamine und Nahrungsergänzungsmittel</span> | Vitamins and supplements</option>
        <option value="7"><span class="german">Komplementärtherapie (Homöopathie, Massage, Ayurveda etc.)</span> | Complementary (homeopathy, massage, ayurveda etc)</option>
        <option value="8"><span class="german">Andere</span> | Other</option>
      </select>
    </div>
	</div>
</template>

<script>
	export default {
		data() {
			return {}
		},
    computed: {
      showableQuestions: function(){
        switch (this.$route.params.checkpoint){
          case 'dayminus30':
            return [0,1,2,3,4,5];
          case 'day0':
            return [0, 6, 7];
          case 'day90':
            return [0, 4,5,6];
          case 'day180':
            return [0, 4,5,6];
          case 'day270':
            return [0, 5,6];
          default:
            return [];
        }
      }
    },
    methods: {
      renderQuestion: function(questionid) {
        if (this.showableQuestions.indexOf(parseInt(questionid)) > -1) {
          return true
        }
        return false
      }
    },
    mounted() {
      $('.ui.dropdown').dropdown();
    }
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/assessment/QnDemographics.vue